// extracted by mini-css-extract-plugin
export default {"matches":"MatchesVideo_matches__T2BWZ","name":"MatchesVideo_name__p4p8A"};